import React, { useRef, useState } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { message } from "antd";
import { handleUploadFile } from "../../../../helpers/helpers";
import "../../DealApproval.scss";

const ALLOWED_EXTENSIONS = [".pdf", ".doc", ".docx"];

const UploadDocumentsForm = ({
    itemIndex,
    blockItem,
    dealId,
    onUpdateBlockItem,
    onDeleteBlockItem,
    showDelete = true,
}) => {
    const fileInputRef = useRef(null);
    const [uploadLoading, setUploadLoading] = useState(false);

    const handleChooseFilesClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileSelection = async (event) => {
        const selectedFiles = Array.from(event.target.files || []);
        if (!selectedFiles.length) return;

        const latestFile = selectedFiles[selectedFiles.length - 1];
        const lowerFileName = String(latestFile?.name || "").toLowerCase();
        const isAllowedFile = ALLOWED_EXTENSIONS.some((extension) =>
            lowerFileName.endsWith(extension),
        );

        if (!isAllowedFile) {
            message.error("Only .pdf, .doc, and .docx files are allowed");
            event.target.value = "";
            return;
        }

        const folderPath = `deals/${dealId || "common"}/section-documents`;
        setUploadLoading(true);

        try {
            const { fileUrl, fileName } = await handleUploadFile(latestFile, folderPath);
            onUpdateBlockItem(itemIndex, "fileName", fileName);
            onUpdateBlockItem(itemIndex, "fileUrl", fileUrl);
            onUpdateBlockItem(itemIndex, "fileType", latestFile.type || "");
            message.success(`${fileName} uploaded successfully`);
        } catch {
            message.error(`Failed to upload ${latestFile.name}`);
        } finally {
            setUploadLoading(false);
            event.target.value = "";
        }
    };

    return (
        <div className="upload-document-block">
            <div className="metric-header-row">
                <h4 className="upload-document-heading">Upload document</h4>
                {showDelete ? (
                    <button
                        type="button"
                        className="card-delete-text-btn"
                        onClick={() => onDeleteBlockItem(itemIndex)}
                    >
                        Delete
                    </button>
                ) : null}
            </div>

            <div className="upload-dropzone">
                <UploadOutlined onClick={handleChooseFilesClick} />
                <h4>Click to upload finalized documents</h4>
                <p>PDF and Word files accepted</p>
                <input
                    ref={fileInputRef}
                    type="file"
                    accept=".pdf,.doc,.docx"
                    style={{ display: "none" }}
                    onChange={handleFileSelection}
                />
                <button
                    type="button"
                    className="file-btn"
                    disabled={uploadLoading}
                    onClick={handleChooseFilesClick}
                >
                    {uploadLoading ? "Uploading..." : "Choose Files"}
                </button>
                {blockItem?.fileName ? (
                    <div className="uploaded-file-list">
                        <p>{blockItem.fileName}</p>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default UploadDocumentsForm;
